import { z } from 'zod';
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
import { BaseFacilityDTOSchema, } from "./facilities.dto.js";
export const FacilitySearchFiltersSchema = z.object({
    name: z.string().optional(),
});
const PaginatedQuerySchema = createPaginatedQuerySchema(FacilitySearchFiltersSchema);
export const FindFacilitiesPaginatedRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseFacilityDTOSchema.shape.companyId,
    }),
    query: PaginatedQuerySchema,
});
//# sourceMappingURL=find-facilities-paginated.dto.js.map